// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { CodeTemplate } from './CodeTemplate';
/**
 * 模板分类 实体类
 * 模板分类
 */
export class TemplateType extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 描述 : 模板的描述信息 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 代码模板 */
  private _codeTemplates: Array<CodeTemplate>;

  /** 获取：代码模板 */
  public get codeTemplates() {
    return this._codeTemplates;
  }

  /** 设置：代码模板 */
  public set codeTemplates(value: Array<CodeTemplate>) {
    this._codeTemplates = value;
  }

  constructor() {
    super();
    this._name = '';
    this._description = '';
    this._codeTemplates = new Array<CodeTemplate>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: TemplateType, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.description = element.description;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.description = json.Description;
    if (json.CodeTemplates && json.CodeTemplates.length > 0) {
      json.CodeTemplates.forEach((element: any) => {
        const codeTemplate = CodeTemplate.Create(element);
        // codeTemplate.templateType = this;
        this.codeTemplates.push(codeTemplate);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Description = this.description;
    if (this.codeTemplates && this.codeTemplates.length > 0) {
      json.CodeTemplates = [];
      this.codeTemplates.forEach((element) => {
        json.CodeTemplates.push(element.toJson());
      });
    }
  }

  static Create(json: any): TemplateType {
    const templateType = new TemplateType();
    templateType.Deserialize(json);
    templateType.json = json;
    return templateType;
  }
}
